import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/collapsible.scss';
import { useEffect, useRef, useState } from 'react';
import { Spacing } from '@front/sharedcomponents/Variables';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { SvgIconType } from '../SvgIcon/SvgIconType';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
export const Collapsible = ({ title, children, initialOpen = false, className, buttonClassName, iconPosition = 'end', onOpened }) => {
    const [isOpen, setIsOpen] = useState(initialOpen);
    const contentRef = useRef(null);
    useEffect(() => {
        if (!contentRef.current)
            return;
        if (isOpen) {
            contentRef.current.removeAttribute('inert');
        }
        else {
            contentRef.current.setAttribute('inert', '');
        }
    }, [isOpen]);
    const containerClassNames = ['collapsible', className];
    const containerClassName = containerClassNames.filter(Boolean).join(' ');
    const btnClassNames = ['collapsible-button', buttonClassName, isOpen ? 'expanded' : 'collapsed'];
    const btnClassName = btnClassNames.filter(Boolean).join(' ');
    const handleTransitionEnd = (e) => {
        if (e.target !== e.currentTarget)
            return;
        if (isOpen)
            onOpened === null || onOpened === void 0 ? void 0 : onOpened();
    };
    const iconElem = (_jsx("div", { className: "collapsible-button-icon", children: _jsx(SvgIcon, { icon: isOpen ? SvgIconType.ArrowDown : SvgIconType.ArrowRight }) }));
    return (_jsxs(Stack, { className: containerClassName, direction: "column", spacing: Spacing.None, children: [_jsxs("button", { className: btnClassName, onClick: () => setIsOpen(!isOpen), children: [iconPosition === 'start' && iconElem, _jsx(Typography, { level: TypographyLevel.BodySm, noWrap: true, children: title }), iconPosition === 'end' && iconElem] }), _jsx("div", { ref: contentRef, className: `collapsible-content ${isOpen ? 'open' : ''}`, onTransitionEnd: handleTransitionEnd, children: _jsx("div", { className: "collapsible-content-inner", children: children }) })] }));
};
